jQuery(function ($) {
  
  function gtag_whatsapp_conversion(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
      gtag('event', 'conversion', {
      'send_to': 'AW-836817700/6FL4CIyU_-0bEKSmg48D',
      'event_callback': callback
  });
    return false;
  }
  
  let c_href=location.href;
  $(document).on(
    'click',
    '#txe-whatsapp-button a.txe-button',
    function () {
      console.log('WhatsApp button clicked2');
      gtag_whatsapp_conversion(c_href);
    }
  );

});